import styled from 'styled-components';

const Top = styled.div`
  position: relative;
`;

export default Top;
